/** Localised relative-time helper for dashboards, activity feeds, lists. */
import { formatDistanceToNowStrict, parseISO } from "date-fns";
import { de, hu, enUS } from "date-fns/locale";

const LOCALES = { en: enUS, de, hu };

export function relativeTime(iso, lang = "en") {
  if (!iso) return "";
  try {
    const d = typeof iso === "string" ? parseISO(iso) : iso;
    if (isNaN(d.getTime())) return "";
    return formatDistanceToNowStrict(d, {
      addSuffix: true,
      locale: LOCALES[lang] || enUS,
    });
  } catch {
    return "";
  }
}
